// extracted by mini-css-extract-plugin
export default {"DeletePopup":"DeletePopup_DeletePopup__omfYh","Body":"DeletePopup_Body__WPRH3","Footer":"DeletePopup_Footer__urEvd"};